'use client';

export default function RefreshButton() {
  return (
    <button
      onClick={() => window.location.reload()}
      className="px-5 py-2.5 sm:px-6 sm:py-3 bg-secondary text-black rounded-lg hover:bg-secondary/90 transition-colors font-medium"
    >
      Refresh Page
    </button>
  );
}